/* =========================================
   myntra-collection.js
========================================= */

(function () {

  const isTouch = !window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function initCards() {
    document.querySelectorAll('.snitch-card:not([data-gallery-init])').forEach(card => {

      card.setAttribute('data-gallery-init', '1');

      const images = card.querySelectorAll('.snitch-img');
      const dots   = card.querySelectorAll('.snitch-dot');

      if (images.length <= 1 || isTouch) return;

      let current  = 0;
      let interval = null;

      function showImage(index) {
        images.forEach(img => img.classList.remove('active'));
        dots.forEach(dot   => dot.classList.remove('active'));
        if (images[index]) images[index].classList.add('active');
        if (dots[index])   dots[index].classList.add('active');
        current = index;
      }

      card.addEventListener('mouseenter', () => {
        clearInterval(interval);
        interval = setInterval(() => {
          showImage((current + 1) % images.length);
        }, 2000);
      });

      card.addEventListener('mouseleave', () => {
        clearInterval(interval);
        interval = null;
        showImage(0);
      });

    });
  }

  initCards();

  const grid = document.querySelector('.myntra-grid');
  if (grid) {
    new MutationObserver(initCards).observe(grid, { childList: true });
  }

  /* =========================================
     SHOW MORE / SHOW LESS
  ========================================= */

  document.addEventListener('click', e => {
    const btn = e.target.closest('.myntra-show-more');
    if (!btn) return;

    const group      = btn.closest('.myntra-filter-group');
    const hidden     = group.querySelectorAll('.myntra-filter-hidden');
    const count      = parseInt(btn.dataset.count) || 0;
    const isExpanded = btn.classList.contains('expanded');

    if (!isExpanded) {
      hidden.forEach(el => el.style.display = 'flex');
      btn.textContent = '− Show less';
      btn.classList.add('expanded');
    } else {
      hidden.forEach(el => el.style.display = 'none');
      btn.textContent = '+ ' + count + ' more';
      btn.classList.remove('expanded');
    }
  });

  /* =========================================
     PRICE RANGE SLIDER
  ========================================= */

  function updatePriceRange(idx, which) {
    const minEl  = document.getElementById('price-min-' + idx);
    const maxEl  = document.getElementById('price-max-' + idx);
    const fillEl = document.getElementById('price-fill-' + idx);
    const minLbl = document.getElementById('price-label-min-' + idx);
    const maxLbl = document.getElementById('price-label-max-' + idx);

    if (!minEl || !maxEl) return;

    const rangeMin = parseFloat(minEl.min);
    const rangeMax = parseFloat(minEl.max);
    let   minVal   = parseFloat(minEl.value);
    let   maxVal   = parseFloat(maxEl.value);

    // Prevent thumbs crossing
    if (which === 'min' && minVal >= maxVal) {
      minVal = maxVal - 1;
      minEl.value = minVal;
    }
    if (which === 'max' && maxVal <= minVal) {
      maxVal = minVal + 1;
      maxEl.value = maxVal;
    }

    // Z-index: dragged thumb always on top
    if (which === 'min') {
      minEl.style.zIndex = '4';
      maxEl.style.zIndex = '3';
    } else if (which === 'max') {
      maxEl.style.zIndex = '4';
      minEl.style.zIndex = '3';
    }

    // Fill calculation — ONLY between the two thumbs
    const total  = rangeMax - rangeMin;
    if (total <= 0) return;

    const pctMin = ((minVal - rangeMin) / total) * 100;
    const pctMax = ((maxVal - rangeMin) / total) * 100;

    // This sets fill ONLY between min and max thumb positions
    if (fillEl) {
      fillEl.style.left  = pctMin + '%';
      fillEl.style.width = (pctMax - pctMin) + '%';
    }

    // Labels
    if (minLbl) minLbl.textContent = '₹' + Math.round(minVal).toLocaleString('en-IN');
    if (maxLbl) maxLbl.textContent = '₹' + Math.round(maxVal).toLocaleString('en-IN') + '+';
  }

  // Expose globally — Liquid uses oninput="updatePriceRange(...)" inline
  window.updatePriceRange = updatePriceRange;

  // Init all sliders — sets correct fill on page load
  function initAllSliders() {
    document.querySelectorAll('.price-range-track').forEach(track => {
      const minEl = track.querySelector('.price-range-min');
      const maxEl = track.querySelector('.price-range-max');
      if (!minEl || !maxEl) return;

      // Set initial z-index
      maxEl.style.zIndex = '3';
      minEl.style.zIndex = '2';

      // Get the idx from the input id
      const idx = minEl.id.replace('price-min-', '');

      const rangeMin = parseFloat(minEl.min);
      const rangeMax = parseFloat(minEl.max);
      const minVal   = parseFloat(minEl.value);
      const maxVal   = parseFloat(maxEl.value);
      const total    = rangeMax - rangeMin;

      const fillEl = document.getElementById('price-fill-' + idx);
      const minLbl = document.getElementById('price-label-min-' + idx);
      const maxLbl = document.getElementById('price-label-max-' + idx);

      if (total <= 0 || !fillEl) return;

      // KEY FIX: pctMin is left edge, pctMax - pctMin is width
      // This means ONLY the segment between thumbs gets pink
      const pctMin = ((minVal - rangeMin) / total) * 100;
      const pctMax = ((maxVal - rangeMin) / total) * 100;

      fillEl.style.left  = pctMin + '%';
      fillEl.style.width = (pctMax - pctMin) + '%';

      if (minLbl) minLbl.textContent = '₹' + Math.round(minVal).toLocaleString('en-IN');
      if (maxLbl) maxLbl.textContent = '₹' + Math.round(maxVal).toLocaleString('en-IN') + '+';
    });
  }

  // Run on page load
  initAllSliders();

  // Re-run when mobile filter drawer opens (was hidden, dimensions were 0)
  document.addEventListener('click', e => {
    if (e.target.closest('.mob-bar-btn')) {
      setTimeout(initAllSliders, 80);
    }
  });

})();